import styled from 'styled-components';

const BrowseTileImageText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Avenir', 'Arial', sans-serif;
  color: white;
  font-size: 30px;
  font-weight: 900;
  line-height: 41px;
  width: 100%;
  cursor: pointer;
`;

export default BrowseTileImageText;
